exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-cb6284ca]{font-size:12px;padding-top:10px;text-transform:uppercase}.itogo div[data-v-cb6284ca],.title[data-v-cb6284ca]{font-weight:700}.v[data-v-cb6284ca]{vertical-align:middle}.tbl[data-v-cb6284ca]{border-top:1px solid #dee2e6}.bundle-itogo[data-v-cb6284ca]{overflow-x:hidden}", ""]);

// exports
